import {ChangeDetectorRef, Component, ElementRef, Renderer2} from '@angular/core';
import {AsyncPipe} from '@angular/common';
import {EventDispatcherService} from '../../../../../projects/mydocma/dynamic-form/src/lib/events/event-dispatcher.service';
import {DynamicFormService} from '../../../../../projects/mydocma/dynamic-form/src/lib/dynamic-form/dynamic-form.service';
import {TextFieldConfig} from '../../../../../projects/mydocma/dynamic-form/src/lib/fields/text/text-field.config';
import {BaseFieldComponent} from '../../../../../projects/mydocma/dynamic-form/src/lib/fields/base/base-field/base-field.component';

@Component({
    selector: 'app-custom-field-company',
    templateUrl: './custom-field-company.component.html',
    styleUrls: ['./custom-field-company.component.scss'],
    providers: [AsyncPipe]
})
export class CustomFieldCompanyComponent extends BaseFieldComponent<TextFieldConfig> {

    public readonly staticCssClass = 'mydocma-custom-field';

    constructor(
        public readonly dynamicFormService: DynamicFormService,
        public readonly changeDetectorRef: ChangeDetectorRef,
        public readonly eventDispatcher: EventDispatcherService,
        element: ElementRef,
        renderer: Renderer2
    ) {
        super(dynamicFormService, changeDetectorRef, eventDispatcher,element,renderer);
    }
}
